import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed left-0 top-0 z-10 flex h-[72px] w-full items-center border-b-4 border-grey bg-white" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`ml-[12px] flex  h-[72px] items-center`)
}
const _hoisted_3 = { class: "flex w-full items-center justify-between" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex items-center space-x-[12px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_version_dropdown = _resolveComponent("version-dropdown")!
  const _component_language_dropdown = _resolveComponent("language-dropdown")!
  const _component_user_dropdown = _resolveComponent("user-dropdown")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: _normalizeClass(`h-10`),
          src: _ctx.generateLogoPath(),
          alt: "logo"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`flex h-16  items-center justify-end space-x-6 ${
        _ctx.sidebarStore.isSidebarOpened ? 'header-inner' : 'w-full'
      } mx-auto mr-[12px] text-white`)
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_version_dropdown),
        _createVNode(_component_language_dropdown),
        _createVNode(_component_user_dropdown)
      ])
    ], 2)
  ]))
}